<template>
  <div class="evaluation">
    <div class="d-none d-md-block">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <device-info/>
  </div>
</template>

<script>
import DeviceInfo from '@/components/DeviceInfo';

export default {
  components: { DeviceInfo },
};
</script>



// WEBPACK FOOTER //
// src/views/Evaluation/Index.vue